module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy S10+ Prism White.1f3f5d86.png";